export enum designLogoTypes {
    FETCH_DESIGN_LOGO_REQUEST = 'FETCH_DESIGN_LOGO_REQUEST',
    EDIT_DESIGN_LOGO_REQUEST = 'EDIT_DESIGN_LOGO_REQUEST',
    SET_DESIGN_LOGO = 'SET_DESIGN_LOGO',
}
